import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Linkedin, Facebook } from "lucide-react";
export default function FooterArchive() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const currentYear = new Date().getFullYear();
  const secondaryLinks = [];
  const socialLinks = [{
    label: "4667 Green park rd\nSt. louis, MO 63123",
    href: "https://www.google.com/maps/search/?api=1&query=4667+Green+Park+Rd,+St.+Louis,+MO+63123"
  }, {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/workplace-technology-solutions"
  }, {
    label: "Facebook",
    href: "https://www.facebook.com/SchaefferElectric/"
  }];
  return <section data-section-id="17210" id="wts-footer" className="dark bg-background text-foreground w-full">
      <Separator className="bg-primary opacity-100" />
      
      <div ref={ref} className={`container mx-auto px-6 py-16 transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/HomePage" className="block">
              <img src="https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/WTS-LOGO_GRAYRED.png" alt="Workplace Technology Solutions" className="object-contain brightness-0 invert !h-[60px] !w-[120px]" />
            </Link>
            <Link to="https://schaefferelectric.com/" className="text-sm text-muted-foreground font-sans tracking-tight">A DIVISION OF SCHAEFFER ELECTRIC</Link>
          </div>

          {}
          <div className="flex flex-col space-y-3 md:items-center md:text-center">
            <nav className="flex flex-col space-y-3">
              {secondaryLinks.map((link, i) => <Link key={i} to={link.href} data-index={i} className="text-sm text-muted-foreground hover:text-primary transition-colors font-mono uppercase tracking-widest">
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col space-y-3 md:items-end md:text-right">
            <div className="flex flex-col space-y-3">
              <Link to={socialLinks[0].href} newTab data-index={0} className="text-sm text-muted-foreground hover:text-primary hover:tracking-widest transition-all font-mono uppercase whitespace-pre-line">
                {socialLinks[0].label}
              </Link>
              <div className="flex items-center gap-4 pt-2 md:justify-end">
                {socialLinks.slice(1).map((social, i) => <Link key={i + 1} to={social.href} newTab data-index={i + 1} className="text-muted-foreground hover:text-primary transition-all">
                    {social.label === "LinkedIn" ? <Linkedin size={20} /> : <Facebook size={20} />}
                  </Link>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}